<template>
  <div class="flex_vh100 mall">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar title="遛遛游戏商城">
        <template #left>
          <div class="flex flex-a-c">
            <van-image
              width="0.8rem"
              height="0.8rem"
              fit="cover"
              :src="getAccountLogo()"
            />
            <div class="wdth80 ofh size12">{{ getAccountNickName() }}</div>
          </div>
        </template>
        <template #right>
          <div style="display: flex; align-items: center" @click="onLogout">
            <van-icon name="revoke" size="24" />
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="flex_vh100">
      <div class="mallgb mymoney flex flex-a-c">
        <div class="flex flex-a-c" style="width: 33.33%">
          <van-image
            width="0.6rem"
            height="0.6rem"
            fit="cover"
            :src="require('@/assets/images_app/icon_diamond.png')"
          />
          <div class="mrgl10">
            {{ accountMoney ? parseMoney(accountMoney.diamond) : 0 }}
          </div>
        </div>
        <div class="flex flex-a-c" style="width: 33.33%">
          <van-image
            width="0.6rem"
            height="0.6rem"
            fit="cover"
            :src="require('@/assets/images_app/icon_gold.png')"
          />
          <div class="mrgl10">
            {{ accountMoney ? parseMoney(accountMoney.gold) : 0 }}
          </div>
        </div>
        <div class="flex flex-a-c" style="width: 33.33%">
          <van-image
            width="0.6rem"
            height="0.6rem"
            fit="cover"
            :src="require('@/assets/images_app/icon_roomcard.png')"
          />
          <div class="mrgl10">
            {{ accountMoney ? parseMoney(accountMoney.roomCard) : 0 }}
          </div>
        </div>
      </div>
      <div class="mallgb flex_vh100">
        <van-tabs
          v-model="activeTab"
          sticky
          swipeable
          :swipe-threshold="4"
          class="flex_vh100"
        >
          <van-tab
            v-for="(item, idx) in categoryList"
            :key="idx"
            :title="item.name"
            class="tab_content"
          >
            <mallList
              :tabindex="idx"
              :activetab="activeTab"
              :categoryId="item.categoryId"
              :tokenCode="tokenCode"
            ></mallList>
          </van-tab>
        </van-tabs>
      </div>
      <div class="mallfoot flex flex-a-c justify-content size12">
        游戏币仅限在遛遛游戏中购买道具或服务，不可兑换现金或转让。
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetMallCategoryInfo,
  CheckPayToken,
  GetMoneyInfo,
  GetAccountName,
  LoginOut,
} from "../api/mallapi.js";
import mallList from "./controls/MallList";
import { Dialog, Toast } from "vant";
export default {
  name: "Mall",
  watch: {
    // 监听整个 $route 对象
    $route(to, from) {
      if (to.name == "Mall") {
        this._getAccountName();
        this._getMoneyInfo();
        var userInfo = this.getUserInfo();
        if (!userInfo) {
          return;
        }
        if (userInfo.logonId != this.userInfo.logonId) {
          this.Init();
        }
      }
    },
  },
  data() {
    return {
      activeTab: 0,

      categoryList: [],

      tokenCode: "",
      userInfo: {},

      accountInfo: {},
      accountMoney: {},
    };
  },
  components: {
    mallList,
  },
  methods: {
    async Init() {
      this.tokenCode = this.$route.query.token;

      if (this.tokenCode) {
        await this._checkPayToken();
      }

      var userInfo = this.getUserInfo();
      if (!userInfo) {
        return;
      }
      this.userInfo = userInfo;

      this._getAccountName();
      this._getMoneyInfo();
      this._getMallCategoryInfo();
    },

    parseMoney(gold) {
      if (gold < 10000) {
        return gold;
      }
      if (gold < 100000000) {
        return (gold / 10000).toFixed(2) + "万";
      }
      if (gold >= 100000000) {
        return (gold / 100000000).toFixed(2) + "亿";
      }
    },

    getAccountLogo() {
      if (this.userInfo.loginType == 1 && this.accountInfo.wc_logo) {
        return this.accountInfo.wc_logo;
      }
      if (this.userInfo.loginType != 1 && this.accountInfo.p_logo) {
        return this.accountInfo.p_logo;
      }
      if (this.accountInfo.p_logo) {
        return this.accountInfo.p_logo;
      }
      if (this.accountInfo.wc_logo) {
        return this.accountInfo.wc_logo;
      }
      if (this.accountInfo.p_sex == 1) {
        //默认男性头像
        return require("@/assets/images_app/icon_man.png");
      }
      if (this.accountInfo.p_sex == 2) {
        //默认女性头像
        return require("@/assets/images_app/icon_woman.png");
      }
      //默认头像
      return require("@/assets/images_app/icon_head.png");
    },

    getAccountNickName() {
      if (this.userInfo.loginType == 1 && this.accountInfo.wc_nickName) {
        return this.accountInfo.wc_nickName;
      }
      if (this.userInfo.loginType != 1 && this.accountInfo.p_nickName) {
        return this.accountInfo.p_nickName;
      }
      if (this.accountInfo.p_nickName) {
        return this.accountInfo.p_nickName;
      }
      if (this.accountInfo.wc_nickName) {
        return this.accountInfo.wc_nickName;
      }
      return "";
    },

    getUserInfo() {
      var userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        return JSON.parse(userInfo);
      }
      var prePath = this.buildNewPath();
      this.$router.push({
        name: "Login",
        query: {
          prePath: prePath,
        },
      });
      return null;
    },

    buildNewPath() {
      const prePath = window.location.hash
        ? window.location.hash.substring(1) // hash模式
        : window.location.pathname + window.location.search; // history模式

      // 分离路径和查询部分
      const [path, queryString] = prePath.split("?");

      var newHash = path;
      if (queryString) {
        // 使用 URLSearchParams 处理参数
        const searchParams = new URLSearchParams(queryString);
        searchParams.delete("token");

        // 重新构建新的查询字符串
        const newQueryString = searchParams.toString();
        newHash = newQueryString ? `${path}?${newQueryString}` : path;
      }

      return newHash;
    },

    onLogout() {
      Dialog.confirm({
        title: "提示",
        message: "您确定要退出遛遛游戏商城吗？",
        confirmButtonText: "确定退出",
        cancelButtonText: "再想想",
        confirmButtonColor: "#ee0a24", // 确认按钮为红色
      })
        .then(() => {
          // 用户点击了"确定退出"
          this._loginOut().then((res) => {
            this.$router.push({
              name: "Login",
            });
          });
        })
        .catch(() => {
          // 用户点击了"再想想"或点击了遮罩层
        });
    },

    //读取商城商品分类列表
    _getMallCategoryInfo() {
      var par = {};
      return GetMallCategoryInfo(par).then((res) => {
        this.categoryList = res;
      });
    },

    //根据token验证是否登录
    _checkPayToken() {
      var par = {
        tokenCode: this.tokenCode,
      };
      return CheckPayToken(par).then((res) => {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            accountId: res.accountId,
            logonId: res.logonId,
            account_no: res.number,
            loginType: res.loginType,
          })
        );
      });
    },

    //读取账户基本信息
    _getAccountName() {
      var par = {
        account_no: this.userInfo.account_no,
      };
      return GetAccountName(par).then((res) => {
        this.accountInfo = res;
      });
    },

    //读取账户资金信息
    _getMoneyInfo() {
      var par = {
        logon_id: this.userInfo.logonId,
        accountId: this.userInfo.accountId,
      };
      return GetMoneyInfo(par).then((res) => {
        this.accountMoney = res;
      });
    },

    //登出账号
    _loginOut() {
      return LoginOut();
    },
  },
  mounted() {
    this.Init();
  },
};
</script>

<style scoped>
.mallgb {
  background: white;
  margin-left: 8px;
  margin-right: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.mymoney {
  height: 42px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 8px;
}

.tab_content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f7f8fa;
  height: 100%;
}

.mallfoot {
  height: 6%;
  background: #eee4ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>

<style>
.mall .van-tabs__content {
  height: 100%;
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}
</style>